import React from "react"
import { css } from "styled-components"
import { Spacer } from "../atoms/layout-primitives"
import VariantContainer from "../atoms/variant-container"
import { BT } from "../styles/blog-typography"

interface IBreadcrumbsProps {
  children: React.ReactNode[]
  delim?: string
}

/**
 * Renders a breadcrumb trail
 * @param delim - delimiter between breadcrumbs, default is "/"
 * @example <BreadCrumbs delim=">">
 * <Link to="#">Home</Link>
 * <Link to="#">Blog</Link>
 * <>Post</>
 * </BreadCrumbs>
 */
const Breadcrumbs = ({ children: crumbs, delim = "/" }: IBreadcrumbsProps) => {
  return (
    <VariantContainer
      variants={[
        css`
          grid-column: 1/-1;
          ${BT.sm.info`400`};
          color: var(--slate);
          a {
            text-decoration: inherit;
            color: inherit;
            font-size: 12px;
          }
          .inactive {
            opacity: 0.45;
          }
          .active {
            opacity: 1;
            font-weight: 500;
          }
        `,
        css`
          a {
            font-size: 14px;
          }
        `,
      ]}
    >
      {crumbs.map((crumb, index) =>
        index < crumbs.length - 1 ? (
          <span key={index} className="inactive">
            {crumb} {delim}{" "}
          </span>
        ) : (
          // Last crumb is active with no backslash
          <span key={index} className="active">
            {crumb}
          </span>
        )
      )}
    </VariantContainer>
  )
}

export default Breadcrumbs
